import { getSession, logWorkspace, serviceState } from '../..';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import appManager from '@app/appManager';
import {
  ServiceSessionEvent,
  ServiceSessionEventType,
} from '../../types/ServiceEvents';

// this is the handler that is triggered when user hangs up the call
async function handleSessionDeleted(event: Telecom.SessionDeletedEvent) {
  logWorkspace('service:session:deleted', event);

  appManager.events.emit<ServiceSessionEvent>(ServiceSessionEventType.DELETED, {
    sessionId: event.conversationId,
    sessionSid: event.conversationSid,
  });

  const session = getSession(event.conversationId);
  if (!session) {
    console.warn('session not found', event.conversationId);
    return;
  }

  // clear session
  delete serviceState.sessions[event.conversationId];

  return;
}

export default handleSessionDeleted;
